<template>
  <div class="mps-entity-editor vue-rqf bg-loading" :loading="$root.ui.loading">
    <div class="mps-admin-container">
      <h4>Innstillinger<span v-if="workshop.id" v-text="' for ' + workshop.name"></span></h4>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-name">Navn</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-name" v-model="workshop.name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('name') }" name="name" type="text" placeholder="Name">
          <span v-show="errors.has('name')" class="help is-danger" v-text="errors.first('name')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-slug">Slug</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-slug" v-model="workshop.slug" v-validate="'required|slug'" :class="{'input': true, 'is-danger': errors.has('slug') }" name="slug" type="text" placeholder="Slug">
          <span v-show="errors.has('slug')" class="help is-danger" v-text="errors.first('slug')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-email">Epost</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-email" v-model="workshop.email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" name="email" type="email" placeholder="Email">
          <span v-show="errors.has('email')" class="help is-danger" v-text="errors.first('email')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-contact-email">Kontakt Epost</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-contact-email" v-model="workshop.contact_email" v-validate="'email'" :class="{'input': true, 'is-danger': errors.has('contact_email') }" name="contact_email" type="email" placeholder="Contact email">
          <span v-show="errors.has('contact_email')" class="help is-danger" v-text="errors.first('contact_email')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-phone">Telefon</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-phone" v-model="workshop.phone" v-validate="{required:true, regex: /^[\d\s\+]+$/}" :class="{'input': true, 'is-danger': errors.has('phone') }" name="phone" type="text" placeholder="Phone">
          <span v-show="errors.has('phone')" class="help is-danger" v-text="errors.first('phone')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="ws-city">By</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-city" v-model="workshop.city" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('city') }" name="city" type="text" placeholder="City">
          <span v-show="errors.has('city')" class="help is-danger" v-text="errors.first('city')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="ws-city">Gate</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-street" v-model="workshop.street" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('street') }" name="street" type="text" placeholder="Street">
          <span v-show="errors.has('street')" class="help is-danger" v-text="errors.first('street')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="ws-postal">Postnummer</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-postal" v-model="workshop.postal" v-validate="{required:true, regex: /^\d{4}$/}" :class="{'input': true, 'is-danger': errors.has('postal') }" name="postal" type="text" placeholder="Postal">
          <span v-show="errors.has('postal')" class="help is-danger" v-text="errors.first('postal')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="ws-county">Fylke</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-county" v-model="workshop.county" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('county') }" name="county" type="text" placeholder="County">
          <span v-show="errors.has('county')" class="help is-danger" v-text="errors.first('county')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="ws-opening-times">Åpningstider</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-opening-times" v-model="workshop.opening_times" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('opening_times') }" name="opening_times" type="text" placeholder="Opening times">
          <span v-show="errors.has('opening_times')" class="help is-danger" v-text="errors.first('opening_times')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-longitude">Lengdegrad</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-longitude" v-model="workshop.longitude" v-validate="{required:true, regex: /^\d{1,3}(\.\d+)?$/}" :class="{'input': true, 'is-danger': errors.has('longitude') }" name="longitude" type="text" placeholder="Longitude">
          <span v-show="errors.has('longitude')" class="help is-danger" v-text="errors.first('longitude')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-latitude">Breddegrad</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-latitude" v-model="workshop.latitude" v-validate="{required:true, regex: /^\d{1,3}(\.\d+)?$/}" :class="{'input': true, 'is-danger': errors.has('latitude') }" name="latitude" type="text" placeholder="Latitude">
          <span v-show="errors.has('latitude')" class="help is-danger" v-text="errors.first('latitude')"></span>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-latitude">Status</label>
        <div :class="['mps-input-wrap', 'mps-admin-select']">
          <v-select v-model="status" :options="statuses"></v-select>
        </div>
      </div>
      <div v-if="!$root.isWorkshopUser()" class="mps-control">
        <label class="label" for="ws-href">Landingside</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="ws-href" v-model="workshop.href" :class="{ 'input': true }" name="href" type="text" placeholder="Landing page">
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="ws-fleet_status">
          <span>Fleet status</span>
        </label>
        <div :class="['mps-input-wrap', 'mps-admin-select']">
          <v-select id="ws-fleet_status" v-model="fleet_status" :options="fleet_statuses"></v-select>
        </div>
        <!--
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input true-value="1" false-value="0" id="ws-fleet_status" name="ws-fleet_status" type="checkbox" v-model="workshop.fleet_status"/>
        </div>
        -->
      </div>
      <div class="mps-control">
        <label class="label" for="ws-is_svipps_partner">
          <span>Svipps partner</span>
        </label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input true-value="1" false-value="0" id="ws-is_svipps_partner" name="is_svipps_partner" type="checkbox" v-model="workshop.is_svipps_partner"/>
        </div>
      </div>
      <div class="mps-control">
        <label class="label">Autosvar-tekster</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <ul class="mps-damage-offer-texts-editor">
            <template v-for="(item,idx) in damageOfferTexts">
              <li>
                <span @click="removeDamageOfferText(idx)">x</span><textarea v-model="damageOfferTexts[idx]"></textarea>
              </li>
            </template>
          </ul>
          <button @click="addDamageOfferText" class="mps-admin-btn big">Legg til</button>
        </div>
      </div>
      <div class="mps-control">
        <label class="label">Svar til kunden</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <ul class="mps-damage-offer-texts-editor">
            <template v-for="(item,idx) in offerTexts">
              <li>
                <span @click="removeOfferText(idx)">x</span>
                <label>
                  <input v-model="item.send_offer" true-value="1" false-value="0" type="checkbox"/>
                  Send offer
                </label>
                <input v-model="item.title" :class="{ 'input': true }" type="text" placeholder="Title">
                <textarea v-model="item.text" placeholder="Text"></textarea>

              </li>
            </template>
          </ul>
          <button @click="addOfferText" class="mps-admin-btn big">Legg til</button>
        </div>
      </div>
      <div style="text-align: right">
        <button @click="saveWorkshop" :disabled="errors.any() || $root.ui.loading" class="mps-admin-btn big">Lagre</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    let statuses = [];
    statuses[0] = 'Not active';
    statuses[10] = 'Active';
    statuses[15] = 'Active offer service (not visible for OPQ)';
    statuses[20] = 'Active offer service';
    statuses[30] = 'Active dealerspace';

    let fleet_statuses = [];
    fleet_statuses[0] = 'No fleet';
    fleet_statuses[1] = 'Include fleet';
    fleet_statuses[10] = 'Only fleet';

    return {
      statuses: statuses,
      fleet_statuses: fleet_statuses,
      workshop: {
        "name": null,
        "slug": null,
        "email": null,
        "contact_email": null,
        "phone": null,
        "street": null,
        "postal": null,
        "city": null,
        "county": null,
        "opening_times": "man-fre: 08:00-16:00",
        "longitude": null,
        "latitude": null,
        "status": 0,
        "fleet_status": 1,
        "is_svipps_partner": 0,
        "href": null
      },
      damageOfferTexts: [],
      offerTexts: []
    }
  },
  computed: {
    status: {
      get(){
        let status = parseInt(this.workshop.status);//this.statuses
        status = status ? status : 0;
        return this.statuses[status];
      },
      set(val){
        this.workshop.status = this.statuses.indexOf(val)
      }
    },
    fleet_status: {
      get(){
        let fleet_status = parseInt(this.workshop.fleet_status);//this.statuses
        fleet_status = fleet_status ? fleet_status : 0;
        return this.fleet_statuses[fleet_status];
      },
      set(val){
        this.workshop.fleet_status = this.fleet_statuses.indexOf(val)
      }
    }
  },
  methods: {
    getWorkshop(id){
        var self = this
        self.$root.ui.loading = true;
        let promises = [self.$api.getDamageOfferTexts( id )];
        if(id)
          promises.push(self.$api.getWorkshop( id ));
        Promise.all(promises).then(function( data ) {
            self.offerTexts = data[0]['offerTexts'];
            self.damageOfferTexts = data[0]['damageTexts'];
            if(data[1]){
              self.workshop = data[1];
              //self.workshop.fleet_sttatus = parseInt(self.workshop.fleet_status) ? 1 : 0 ;
              self.workshop.is_svipps_partner = parseInt(self.workshop.is_svipps_partner) ? 1 : 0 ;
            }
            self.$root.ui.loading = false;
        });
    },
    removeDamageOfferText(idx){
      this.damageOfferTexts.splice(idx, 1);
    },
    addDamageOfferText(){
      this.damageOfferTexts.push('');
    },
    removeOfferText(idx){
      this.offerTexts.splice(idx, 1);
    },
    addOfferText(){
      this.offerTexts.push({
        'title': '',
        'text': '',
        'send_offer': 1
      });
    },
    saveWorkshop(){
      let self = this;
      self.$validator.validateAll().then(isValid => {
        if(isValid){
            self.$root.ui.loading = true;
            let texts = {
                damageOfferTexts: self.damageOfferTexts,
                offerTexts: self.offerTexts
            };
            Promise.all([
                self.$api.saveWorkshop(self.workshop),
                self.$api.saveDamageOfferTexts(self.$route.params.id, texts)//getDamageOfferTexts( self.$route.params.id )
            ]).then(function( data ) {
                self.$root.ui.loading = false;
                if( data[0] )
                    self.$router.push('/');
            });
          /*
          self.$api.saveWorkshop(self.workshop).then(isSaved => {
            self.$root.ui.loading = false;
            if(isSaved)
              self.$router.push('/');
          })
          */
        }
      })
      //saveDamageOfferTexts(id_workshop, texts)
    }
  },
  created(){
    this.getWorkshop(this.$route.params.id)
  },
  beforeRouteUpdate: function(to, from, next){
    next()//vm => {}
    this.getWorkshop(to.params.id)
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Workshop.vue?2753855d